/**
 * 避難先の「敷地」として採ってよい大きさの上限 (名前から施設の種類を見分ける)。
 *
 * 敷地の形は「点を含む土地利用 (landuse) の連結」や「点を含む一番大きい敷地」で取るため、
 * 公園の中の学校・美術館などは公園全体を拾ってしまう (実測: 都立上野高等学校が上野公園
 * 全体の約68万㎡、横須賀美術館が約78万㎡)。種類に比べて大きすぎる敷地は採らず、
 * 建物の形 (無ければ円) に回す。
 *
 * 公園・墓地・大学・工場・ゴルフ場など本当に広い場所は名前で見分けて上限を置かない。
 */

/** 本当に広い敷地がありうる施設の名前。 */
const WIDE_NAME =
  /公園|緑地|緑道|広場|グラウンド|グランド|運動場|競技場|球技場|球場|スタジアム|陸上|河川敷|霊園|墓地|墓園|墓苑|森|林|庭園|苑|スポーツ|ゴルフ|カントリー|演習場|基地|駐屯|飛行場|空港|農場|牧場|大学|学園|キャンパス|ふ頭|埠頭|港|ターミナル|工場|事業所|事業場|研究所|発電所|倉庫|市場|一帯|地区|団地|浄水場|処理場|ドーム|アリーナ|競馬|競輪|競艇|オートレース|遊園|動物園|植物園|河川|川|池|湖|浜|海岸|海浜|山|丘|台地|高原|自然|野営|キャンプ|パーク|境内|神宮|大社|寺/;

/** 学校 (校地は広めだが、公園ほどではない)。 */
const SCHOOL_NAME = /学校|小学|中学|高校|高等|義務教育|特別支援|幼稚園|学院|一貫校/;

/** 学校の敷地の上限 (m²)。大きめの高校の校地でも数万㎡。 */
export const SCHOOL_SITE_MAX_M2 = 60_000;
/** それ以外の施設 (会館・センター・保育園・住宅など) の敷地の上限 (m²)。 */
export const FACILITY_SITE_MAX_M2 = 30_000;

/** 名前から決めた敷地の上限 (m²)。広い施設は Infinity。 */
export function maxSiteAreaM2(name: string): number {
  const n = (name ?? '').normalize('NFKC');
  if (WIDE_NAME.test(n)) return Infinity;
  if (SCHOOL_NAME.test(n)) return SCHOOL_SITE_MAX_M2;
  return FACILITY_SITE_MAX_M2;
}

/** 敷地が名前の種類に比べて大きすぎるか。 */
export function isOversizedSite(name: string, areaM2: number): boolean {
  return areaM2 > maxSiteAreaM2(name);
}
